/* Daymark product gallery. Pairs with snippets/daymark-gallery.liquid.
   - arrows and thumbnails change the active slide
   - auto-advances every data-autoplay ms; pauses on hover, focus, hidden tab
   - any manual action restarts the timer so the next auto step is not abrupt */
(function () {
  if (customElements.get('daymark-gallery')) return;

  class DaymarkGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.dm-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.dm-gallery__thumb'));
      this.count = this.slides.length;
      this.index = 0;
      this.interval = parseInt(this.dataset.autoplay || '0', 10);
      this.timer = null;
      if (this.count < 2) return;

      this.addEventListener('click', (e) => {
        const arrow = e.target.closest('.dm-gallery__arrow');
        if (arrow) { this.go(this.index + parseInt(arrow.dataset.dir, 10)); this.restart(); return; }
        const thumb = e.target.closest('.dm-gallery__thumb');
        if (thumb) { this.go(parseInt(thumb.dataset.index, 10)); this.restart(); }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.go(this.index - 1); this.restart(); }
        if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restart(); }
      });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      // Basic swipe on touch devices.
      let x0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
      }, { passive: true });

      this.start();
    }
    disconnectedCallback() { this.stop(); }

    go(i) {
      const next = ((i % this.count) + this.count) % this.count;
      if (next === this.index) return;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.thumbs[this.index].classList.remove('is-active');
      this.thumbs[this.index].removeAttribute('aria-current');
      this.index = next;
      this.slides[next].classList.add('is-active');
      this.slides[next].removeAttribute('aria-hidden');
      this.thumbs[next].classList.add('is-active');
      this.thumbs[next].setAttribute('aria-current', 'true');
    }
    start() {
      if (this.timer || !this.interval) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  customElements.define('daymark-gallery', DaymarkGallery);
})();
